import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";

const ConversionLegend = () => {
  const { t } = useTranslation(["merchandising"]);
  return (
    <div className={css({ display: "flex", gap: "small", alignItems: "center" })}>
      <Badge bg={"tr-success"} className="fs-5">
        {t(($) => $.merchandising["High Conversions"])}
      </Badge>
      <Badge bg={"tr-info"} className="fs-5">
        {t(($) => $.merchandising["Mid Conversions"])}
      </Badge>
      <Badge bg={"tr-warning"} className="fs-5">
        {t(($) => $.merchandising["Low Conversions"])}
      </Badge>
    </div>
  );
};

export default ConversionLegend;
